export default "__VITE_ASSET__B9eLs$Fv__"